<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Control Card" active>

                                <b-row v-if="hasFailedDataControlCard">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedControlCard.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="controlCardsFailed" :fields="fieldsControlCard" :busy="isDataLoading"
                                                         :sort-by.sync="sortByControlCard" :sort-desc.sync="sortDescControlCard" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyCase)="row">
													{{ Number(row.item.qtyCase).toLocaleString() }}
												</template>
												<template #cell(receivingDate)="row">
													{{ row.item.receivingDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>
												<template #cell(deliveryDate)="row">
													{{ row.item.deliveryDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>
												<template #cell(revisi)="row">
													{{ Number(row.item.revisi).toLocaleString() }}
												</template>
												<template #cell(packSequence)="row">
													{{ Number(row.item.packSequence).toLocaleString() }}
												</template>
												<template #cell(totalPack)="row">
													{{ Number(row.item.totalPack).toLocaleString() }}
												</template>
												<template #cell(vendorSubcont)="row">
													{{ row.item.vendorSubcont != null ? row.item.vendorSubcont.name : "" }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedControlCard.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="controlCards" :fields="fieldsControlCard" :busy="isDataLoading"
                                                         :sort-by.sync="sortByControlCard" :sort-desc.sync="sortDescControlCard" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyCase)="row">
													{{ Number(row.item.qtyCase).toLocaleString() }}
												</template>
												<template #cell(receivingDate)="row">
													{{ row.item.receivingDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>
												<template #cell(deliveryDate)="row">
													{{ row.item.deliveryDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>
												<template #cell(revisi)="row">
													{{ Number(row.item.revisi).toLocaleString() }}
												</template>
												<template #cell(packSequence)="row">
													{{ Number(row.item.packSequence).toLocaleString() }}
												</template>
												<template #cell(totalPack)="row">
													{{ Number(row.item.totalPack).toLocaleString() }}
												</template>
												<template #cell(vendorSubcont)="row">
													{{ row.item.vendorSubcont != null ? row.item.vendorSubcont.name : "" }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>
						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardList from '@/models/ControlCard/ControlCardList';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsControlCard: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Control Card Number", key: 'controlCardNumber', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Control Card Type", key: 'controlCardTypeCode', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Qty Case", key: 'qtyCase', sortable: false},
				{"class" : "th-status", "label" : "Area", key: 'areaCode', sortable: false},
				{"class" : "th-status", "label" : "Rack", key: 'rackCode', sortable: false},
				{"class" : "th-status", "label" : "Vendor Subcont", key: 'vendorSubcont', sortable: false},
				//{"class" : "th-status", "label" : "DocNo", key: 'docNo', sortable: false},
				//{"class" : "th-status", "label" : "Status", key: 'status', sortable: false},
				{"class" : "th-status", "label" : "Receiving Date", key: 'receivingDate', sortable: false},
				{"class" : "th-status", "label" : "Delivery Date", key: 'deliveryDate', sortable: false},
				//{"class" : "th-status", "label" : "Transaction Type", key: 'transactionType', sortable: false},
				//{"class" : "th-status", "label" : "Transaction Id", key: 'transactionId', sortable: false},
				//{"class" : "th-status", "label" : "Revisi", key: 'revisi', sortable: false},
				{"class" : "th-status", "label" : "Pack Sequence", key: 'packSequence', sortable: false},
				{"class" : "th-status", "label" : "Total Pack", key: 'totalPack', sortable: false},
				{"class" : "th-status", "label" : "Control Card Status", key: 'controlCardStatusName', sortable: false},
				{"class" : "th-status", "label" : "Qc Status", key: 'qcStatusName', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			controlCards : [],
			controlCardsFailed: [],
			controlCardId : '',
			sortByControlCard: '',
			sortDescControlCard: '',
			hasFailedDataControlCard: false,
			totalFailedControlCard: 0,
			totalSucceedControlCard: 0,

			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('controlcard/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('controlcard/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getControlCardForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getControlCardForUpload : async function() {
			let _this = this;
			this.$http.get('controlcard/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.controlCards = [];


					if (response != null) {
						let result = response.data;
						_this.controlCards = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedControlCard = _this.controlCards.length;

						_this.controlCardsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataControlCard = true;
						_this.totalFailedControlCard = 0;
						if(_this.controlCardsFailed == undefined || _this.controlCardsFailed.length === 0) _this.hasFailedDataControlCard = false;
						if(_this.hasFailedDataControlCard) _this.totalFailedControlCard = _this.controlCardsFailed.length;

						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'controlcard/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'ControlCard.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterControlCard = new ControlCardFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
